// src/components/scan/form/ScanForm.tsx
import { useIsMobile } from '../../../utils/isMobile';
import ScanFormDesktop from './ScanFormDesktop';
import ScanFormMobile from './ScanFormMobile';
import type { ScanFormProps } from './ScanFormDesktop';

export default function ScanFormResponsive(props: ScanFormProps) {
  const isMobile = useIsMobile();
  return isMobile ? (
    <ScanFormMobile {...props} />
  ) : (
    <ScanFormDesktop {...props} />
  );
}
